import { Box, Button } from '@mui/material';

const BackButton = ({ goBack }) => {
   return (
      <Box sx={{ width: '15%', mt: 2 }}>
         <Button
            onClick={goBack}
            sx={{ height: '130px' }}
            fullWidth
            variant="outlined"
            color="primary"
         >
            Back
         </Button>
      </Box>
   );
};

export default BackButton;
